import { useEffect, useState } from 'react';
import miObraService from 'src/services/miObraService';
import { debeConsultarOnboarding, tieneMenuRecortado } from 'src/utils/sorbyIa/cuentaSorbyIa';

// Pregunta por la ventana de onboarding solo a quien no es de alta sola pero tiene onboarding_web;
// al resto no le pega a la API.
export async function consultarOnboardingActivo(empresa) {
  if (!debeConsultarOnboarding(empresa)) return false;
  try {
    const { onboarding } = await miObraService.obtener();
    return onboarding?.activo === true;
  } catch (err) {
    console.error('[onboardingWeb] estado.lectura_fallida', err);
    return false;
  }
}

// Estado para armar el menú: la ventana de onboarding y los módulos en prueba. Solo le pega a la API la cuenta de alta sola
// o la que sigue en onboarding; las demás no hacen ninguna llamada. Las lecturas simultáneas comparten una sola.
let lecturaEnCurso = null;
export const leerMiObra = () => {
  if (!lecturaEnCurso) {
    lecturaEnCurso = miObraService.obtener().finally(() => {
      lecturaEnCurso = null;
    });
  }
  return lecturaEnCurso;
};

export async function consultarEstadoSorbyIa(empresa) {
  const vacio = { onboardingActivo: false, modulos: [] };
  if (!debeConsultarOnboarding(empresa) && !tieneMenuRecortado(empresa)) return vacio;
  try {
    const { onboarding, modulos } = await leerMiObra();
    return { onboardingActivo: onboarding?.activo === true, modulos: Array.isArray(modulos) ? modulos : [] };
  } catch (err) {
    console.error('[onboardingWeb] estado.lectura_fallida', err);
    return vacio;
  }
}

// `empresa` undefined = todavía no se cargó; null = cuenta sin empresa.
export function useOnboardingWeb(empresa) {
  const [estado, setEstado] = useState({ listo: false, activo: false });

  useEffect(() => {
    if (empresa === undefined) return undefined;
    let vigente = true;
    consultarOnboardingActivo(empresa).then((activo) => {
      if (vigente) setEstado({ listo: true, activo });
    });
    return () => {
      vigente = false;
    };
  }, [empresa]);

  return estado;
}
